var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { MainLayout, Overlay } from "./Styles/Styles";
import Ad from "./Ad/Ad";
import Button from "./connect-ui/Button";
import Header from "./Header";
import { ImpressionType } from "../lib/constants";
import { LoadingCircle } from "./LoadingIcon";
import NoAdsFound from "./NoAdsFound";
import { SimpleTextPhase } from "./SimpleTextPhase";
import { resetLocationState } from "../features/navigation/navigationSlice";
import useAppDispatch from "../hooks/useAppDispatch";
import useAppSelector from "../hooks/useAppSelector";
import useCanShowMidFunnelAds from "../features/configuration/useCanShowMidFunnelAds";
import useSearchResults from "../services/savvy/useSearchResults";
import { viewedWidgetPage } from "../lib/Avo";
function ErrorScreenAds() {
    var _a = useSearchResults({ impressionTypeOverride: ImpressionType.Standard }).searchQuery, isSuccess = _a.isSuccess, data = _a.data, isLoading = _a.isLoading;
    return (React.createElement("div", { className: "flex w-full grow flex-col overflow-hidden" },
        React.createElement("header", { className: "mb-4 px-4" },
            React.createElement("h2", { className: "mb-2 text-center text-2xl font-normal" }, "Sorry, an error occurred"),
            React.createElement("p", { className: "text-center text-lg text-black-200" }, "We still tried to find you the best auto insurance rates in your area:")),
        React.createElement("div", { className: "grow overflow-y-auto px-4" },
            isLoading ? (React.createElement("div", { id: "midfunnelads_loading", className: "m-auto w-[50px]" },
                React.createElement(LoadingCircle, null))) : null,
            isSuccess && data ? (React.createElement("div", { className: "ads space-y-4 pb-4" }, data.ads.length === 0 ? (React.createElement(NoAdsFound, null)) : (data.ads.map(function (ad, idx) { return (React.createElement(Ad, { key: ad.id, ad: ad, index: idx, impressionId: data.impressionId, className: "border border-gray-300", impressionType: ImpressionType.Standard })); })))) : null)));
}
function ErrorScreen(_a) {
    var onCloseRequested = _a.onCloseRequested;
    var canShowMidFunnelAds = useCanShowMidFunnelAds();
    var commonAnalyticsProperties = useAppSelector(function (state) { return state.analytics; }).commonAnalyticsProperties;
    var dispatch = useAppDispatch();
    function handleCloseClick() {
        onCloseRequested === null || onCloseRequested === void 0 ? void 0 : onCloseRequested();
    }
    React.useEffect(function () {
        viewedWidgetPage(__assign({ segmentPageName_: "Error" }, commonAnalyticsProperties));
    }, [commonAnalyticsProperties]);
    React.useEffect(function () {
        dispatch(resetLocationState());
    }, [dispatch]);
    return (React.createElement(Overlay, null,
        React.createElement(MainLayout, { style: { backgroundColor: "#fff" } },
            React.createElement(Header, { onClose: handleCloseClick }),
            canShowMidFunnelAds ? (React.createElement(ErrorScreenAds, null)) : (React.createElement(SimpleTextPhase, { title: "An error occurred" },
                React.createElement("p", { className: "mt-[-40px] text-center text-lg text-black-200" }, "We're sorry, an error occurred. Please try again."),
                React.createElement(Button, { className: "mt-12", type: "button", onClick: handleCloseClick }, "Close"))))));
}
export default ErrorScreen;
